import { DEFAULT_LOCATIONS, QUANTUM_SANDBOX, PASSWORD } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token NA', // hardcoded to staging for sandbox demo
  staging: 'Token a3eff8a4a6f16dc4f60cdfbf64066422b64be916',
  prod: 'Token NA', // hardcoded to staging for sandbox demo
};

const token = selectToken(apiTokens);

const quantumSandboxConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'quantumsandbox',

  API_TOKEN: token,
  EMBOLD_CLIENT: QUANTUM_SANDBOX,

  // login
  SHOW_REGION_SELECTOR: true,
  PASSWORD_REGEX: ['quantumsandbox|demo', 'i'],

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Nashville },
  LOGIN_NETWORK_NAME: 'quantumSandboxUserId',

  // content
  DISPLAY_NAME: 'Quantum Health Sandbox',
  FORM_VARIANT: PASSWORD,
  NO_WELCOME_LINK: true,
};

export default quantumSandboxConfig;
